export const creatorImages = [
  // Previously added creators
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/dfqa4m0s_Ananya%20Nagalla%20%286%29.jpg.jpeg",
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/kydwmykp_krithi%20shetty.webp",
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/se8l1vu6_740full-nabha-natesh.jpg.jpeg",
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/pytawe8y_503281-b2v0vqj5.webp",
  // Newly added creators
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/ceuyfcex_Pranavi%20Manukonda.jpg.jpeg",
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/z80xe8rz_samyukatha%20menon.webp",
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/hnlr35sb_SaveGram.App_468952259_18465501415042223_6505824025095430433_n.jpg.jpeg",
  // Latest additions
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/61pvb80v_SaveGram.App_654142734_18159280804438426_276886293212125892_n.jpg.jpeg",
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/y1k3b39n_shreeleela.jpg.jpeg",
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/a9a7xp4y_Tollywood%20Actor%20Babloo%20Prithiveeraj%20Rare%20And%20Unseen%20photos_20.jpg.jpeg",
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/kmz7cjdg_SaveGram.App_621801996_18120791827568372_8647073413363901388_n.jpg.jpeg",
  // Newest additions
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/oruzbigs_SnapInsta.to_656001489_18573763900007093_7968096009008031628_n.jpg.jpeg",
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/sy6zsbcv_Gemini_Generated_Image_g70xxdg70xxdg70x.png",
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/m4nv5l2s_images%20%281%29.jpeg",
  "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/vvur5p6v_SnapInsta.to_484269262_18094149556559519_7586099246352290887_n.jpg.jpeg",
];

export const services = [
  {
    id: "influencer-campaigns",
    title: "Influencer Campaigns",
    tag: "CORE",
    description:
      "Full-funnel creator campaigns engineered for measurable reach, resonance and response across South India's top regional voices.",
    bullets: ["Creator Discovery", "Narrative Scripting", "Performance Tracking"],
  },
  {
    id: "story-led-campaigns",
    title: "Story-Led Campaigns",
    tag: "NARRATIVE",
    description:
      "We craft stories first, campaigns second. Arcs that audiences actually watch — not skip.",
    bullets: ["Screen-writing", "Arc Design", "Episodic Rollouts"],
  },
  {
    id: "celebrity-endorsements",
    title: "Celebrity Endorsements",
    tag: "PRESTIGE",
    description:
      "Access to Telugu, Tamil, Kannada and Malayalam cinema, sports and regional icons — on brief, on budget.",
    bullets: ["Talent Booking", "Contract & IP", "Shoot Production"],
  },
  {
    id: "sequential-campaigns",
    title: "Sequential Campaigns",
    tag: "SCALE",
    description:
      "Coordinated multi-creator drops designed to manufacture cultural moments — not isolated posts.",
    bullets: ["Rollout Strategy", "Wave Scheduling", "Momentum Analytics"],
  },
];

export const campaigns = [
  {
    title: "Neon City — Red Label Drop",
    category: "Fashion · Telugu",
    reach: "14.2M",
    views: "38.6M",
    engagement: "9.8%",
    image:
      "https://images.unsplash.com/photo-1549664846-c899b984c174?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
  {
    title: "Flipkart: Big Billion Days Campaign",
    category: "Fashion · D2C",
    reach: "7M+",
    engagement: "10%",
    creators: "10+",
    image:
      "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/jyzjwhhp_Gemini_Generated_Image_cq1wy9cq1wy9cq1w.png",
  },
  {
    title: "Myron Dynasty Campaign",
    category: "Lifestyle · Pan-South",
    reach: "5M+",
    engagement: "8%",
    creators: "15+",
    image:
      "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/qkpwynvf_Myron.png",
  },
  {
    title: "UpGrad: Knowledge Hut Campaign",
    category: "EdTech · Pan-India",
    reach: "20M+",
    engagement: "8.5%",
    creators: "50+",
    image:
      "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/1d4h4d3r_upgrad.png",
  },
];

export const brandLogos = [
  { name: "Flipkart", src: "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/2edya712_Flipkart-Logo.wine.png", scale: 0.8 },
  { name: "KFC", src: "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/kc390x1n_KFC-Logo-PNG-Free-File-Download.png", scale: 1 },
  { name: "Amazon", src: "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/1apodvuf_Amazon_PNG6.png", scale: 0.6 },
  { name: "Axis Bank", src: "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/8zy3cfsh_Axis_Bank_logo.svg.png", scale: 1 },
  { name: "Federal Bank", src: "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/pbb2u0n4_Federal_Bank_Logo.png", scale: 1.3 },
];

export const testimonials = [
  {
    quote: "Affix didn't just run our campaign — they built a story audiences couldn't scroll past. Our Tamil launch did 3x the reach we projected.",
    name: "Babloo Prithiveeraj",
    image: "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/a9a7xp4y_Tollywood%20Actor%20Babloo%20Prithiveeraj%20Rare%20And%20Unseen%20photos_20.jpg.jpeg",
  },
  {
    quote: "We've worked with four agencies before Affix. None understood regional creator culture this deeply. Finally a partner who gets it.",
    name: "Samyuktha",
    image: "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/z80xe8rz_samyukatha%20menon.webp",
  },
  {
    quote: "The sequential rollout strategy was a revelation. One launch turned into a three-week cultural moment across Kerala.",
    name: "Sreeleela",
    image: "https://customer-assets.emergentagent.com/job_regional-creator-hub/artifacts/y1k3b39n_shreeleela.jpg.jpeg",
  },
];

export const processStepImages = [
  "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
  "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80",
  "https://images.unsplash.com/photo-1542744095-291d1f67b221?w=800&q=80",
  "https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?w=800&q=80",
  "https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=800&q=80",
  "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
];

export const team = [
  { name: "Rahul Menon", role: "Founder & Campaign Director", image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=600&q=80" },
  { name: "Ananya Iyer", role: "Head of Creator Partnerships", image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=600&q=80" },
  { name: "Karthik Reddy", role: "Narrative Lead", image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=600&q=80" },
  { name: "Meera Nair", role: "Regional Strategy — Malayalam", image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=600&q=80" },
  { name: "Siddharth R.", role: "Production & Post", image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=600&q=80" },
  { name: "Priya Lakshmi", role: "Performance & Insights", image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&q=80" },
];

export const regions = [
  { lang: "Telugu", stat: "8.2M+ monthly reach", note: "Andhra · Telangana" },
  { lang: "Tamil", stat: "10.4M+ monthly reach", note: "Tamil Nadu · Puducherry" },
  { lang: "Kannada", stat: "6.1M+ monthly reach", note: "Karnataka" },
  { lang: "Malayalam", stat: "5.7M+ monthly reach", note: "Kerala · Gulf" },
];
